/**
 * Signal from chef pages to the app shell that a heavy side panel is
 * open (e.g. deliverable detail drawer at /orders/kitchen). The AppShell
 * subscribes and collapses `OrdoSidebar` while the flag is true, mirroring
 * the chefs-v2 standalone behavior where opening the detail panel
 * automatically narrows the sidebar to give the panel breathing room.
 *
 * Only the chef pages flip this. Other personas leave it false.
 */
import { create } from 'zustand'

interface ChefSidebarState {
  collapsed: boolean
  setCollapsed: (next: boolean) => void
}

export const useChefSidebarCollapse = create<ChefSidebarState>((set) => ({
  collapsed: false,
  setCollapsed: (next) => set({ collapsed: next }),
}))
